<template>
  <div id="container">
    <!-------------- 发货信息 -------------->
    <shipping-information ref="shippingInformationRefs"></shipping-information>
    <!-------------- 发货详情 -------------->
    <shipment-information-details :pcdbId="id" ref="shippingInformationDetailsRefs"></shipment-information-details>
    <!-------------- 工单日志 -------------->
    <operation-log-and-flow :flowLabel="type==='入库'?'采购入库发货流程':'采购直发流程'" :id="id"></operation-log-and-flow>
  </div>
</template>
<script>
import shippingInformation from './shippingInformation' // 发货信息
import operationLogAndFlow from '@/components/OperationLog/operationLogAndFlow' // 工单日志
import shipmentInformationDetails from './shipmentInformationDetails' // 发货详情
import { queryByDeliverNumber } from '@/api/purchase/purchasePlanList' // 根据采购合同id查询正常产品清单（分页)

export default {
  components: {
    'shipping-information': shippingInformation,
    'shipment-information-details': shipmentInformationDetails,
    'operation-log-and-flow': operationLogAndFlow
  },
  data () {
    return {
      id: '',
      type: '',
      content: '',
      title: '',
      deliverState: undefined
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    // 写到这个请求,等后台给状态
    getList () {
      queryByDeliverNumber(this.$route.query.deliverNumber)
        .then((res) => {
          if (res.data.code === 200) {
            this.id = res.data.obj.pcdbId
            const params = {
              deliverNumber: res.data.obj.deliverNumber, // 发货编号
              deliverType: res.data.obj.deliverType, // 发货方式
              createDate: res.data.obj.createDate, // 发起时间
              storageName: res.data.obj.storageName, // 入库仓库
              storageAddress: res.data.obj.storageAddress, // 仓库地址
              storagePhone: res.data.obj.storagePhone, // 联系电话
              receivePeople: res.data.obj.receivePeople // 收货人
            }
            this.type = res.data.obj.deliverType
            this.$refs.shippingInformationRefs.onInitial(params)
            this.$refs.shippingInformationDetailsRefs.onInitial(
              res.data.obj.deliverType,
              res.data.obj.purchaseContractDeliverBasesVo
            )
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
